import { useEffect } from "react";

const getStoredTimerEndTime = () => {
  const savedTimer = localStorage.getItem("studyTimer");
  if (!savedTimer) return null;

  const endTime = parseInt(savedTimer, 10);
  if (!Number.isFinite(endTime) || endTime <= Date.now()) return null;
  return endTime;
};

const useStudyTimerExtension = (setTimerEndTime, setTimerDisplay) => {
  useEffect(() => {
    const handleTimerExtended = (event) => {
      const eventEndTime = event.detail?.endTime;
      const endTime = Number.isFinite(eventEndTime)
        ? eventEndTime
        : getStoredTimerEndTime();

      if (!endTime) return;
      setTimerEndTime(endTime);
      if (setTimerDisplay) setTimerDisplay("");
    };

    window.addEventListener("study-timer-extended", handleTimerExtended);
    return () =>
      window.removeEventListener("study-timer-extended", handleTimerExtended);
  }, [setTimerDisplay, setTimerEndTime]);
};

export default useStudyTimerExtension;
